"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectFastClickDirective = injectFastClickDirective;

var _logTrack = require("../logTrack");

var _common = require("../common");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function injectFastClickDirective(vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (vue && vue.directive) {
    // document.addEventListener('DOMContentLoaded', () => {
    //   FastClick.attach(document.body);
    // }, false);
    var directiveHandler = function directiveHandler(el, bind) {
      var value = bind.value;

      if (!(0, _common.isFn)(value)) {
        /* eslint-disable no-console */
        console.error('fastclick 绑定值必须是一个函数');
        return;
      } // 做标记


      el.dataset.igc_click = 1;

      var callback = function callback() {
        var log = el.dataset.igc_log;

        if (!(0, _common.isNil)(log) && (0, _common.isStr)(log)) {
          try {
            log = JSON.parse(log);
          } catch (e) {
            log = undefined;
          }
        } // 获取 trackName 事件名称


        var trackName = (0, _common.findTrackName)(log);

        _logTrack.LogTrack.track(_objectSpread({
          event_type: 'click',
          $el: el
        }, log), trackName);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        value.apply(el, args);
      };

      if (el.fastclickOldBindValue) {
        el.removeEventListener('click', el.fastclickOldBindValue);
      } // 下面解绑使用


      el.fastclickOldBindValue = callback; // 开始绑定

      el.addEventListener('click', callback);
    }; // fastclick 指令


    vue.directive('fastclick', {
      bind: directiveHandler,
      update: directiveHandler,
      unbind: function unbind(el) {
        // 解除绑定
        el.removeEventListener('click', el.fastclickOldBindValue);
        delete el.dataset.igc_click;
      }
    });
  }
}